import produce from 'immer'
import { CarouseltoppagesAction, CarouseltoppagesActionTypes } from '../actions/carouseltoppagesActions'
import { ApiStatus, ICarouseltoppagesItem } from '../models'

export const initialCarouseltoppagesState: ICarouseltoppagesState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  carouseltoppages: [],
  foundcarouseltoppages: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function carouseltoppagesReducer(state: ICarouseltoppagesState = initialCarouseltoppagesState, action: CarouseltoppagesAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CarouseltoppagesActionTypes.SEARCH_CAROUSELTOPPAGES:
        draft.searchString = action.searchOptions.searchString
        break
      case CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CarouseltoppagesActionTypes.FOUND_CAROUSELTOPPAGES:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundcarouseltoppages.push(...action.payload.carouseltoppages.docs)
          : (draft.foundcarouseltoppages = action.payload.carouseltoppages.docs)
        draft.totalDocs = action.payload.carouseltoppages.totalDocs
        break

      case CarouseltoppagesActionTypes.LOAD_CAROUSELTOPPAGES:
      case CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcarouseltoppages = []
        break

      case CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CarouseltoppagesActionTypes.LOADED_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.LOADED
        draft.carouseltoppages = action.payload.carouseltoppages.docs
        draft.totalDocs = action.payload.carouseltoppages.totalDocs
        break

      case CarouseltoppagesActionTypes.ADD_CAROUSELTOPPAGES:
      case CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CarouseltoppagesActionTypes.ADDED_CAROUSELTOPPAGES:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.carouseltoppages.push(action.payload.carouseltoppages.docs[0])
        if (draft.searchString) draft.foundcarouseltoppages.push(action.payload.carouseltoppages.docs[0])
        break

      case CarouseltoppagesActionTypes.REMOVE_CAROUSELTOPPAGE:
        draft.carouseltoppages.splice(
          draft.carouseltoppages.findIndex((carouseltoppage) => carouseltoppage._id === action.payload._id),
          1
        )
        break

      case CarouseltoppagesActionTypes.SOFT_REMOVE_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CarouseltoppagesActionTypes.SOFT_REMOVED_CAROUSELTOPPAGES:
        draft.addingStatus = ApiStatus.LOADED
        draft.carouseltoppages.splice(
          draft.carouseltoppages.findIndex((carouseltoppage) => carouseltoppage._id === action.payload._id),
          1
        )
        break

      case CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CarouseltoppagesActionTypes.EDIT_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CarouseltoppagesActionTypes.EDITED_CAROUSELTOPPAGES:
        draft.addingStatus = ApiStatus.LOADED
        draft.carouseltoppages[draft.carouseltoppages.findIndex((carouseltoppage) => carouseltoppage._id === action.payload._id)] = action.payload
        draft.foundcarouseltoppages[draft.foundcarouseltoppages.findIndex((carouseltoppage) => carouseltoppage._id === action.payload._id)] =
          action.payload
        break

      case CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICarouseltoppagesState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  carouseltoppages: ICarouseltoppagesItem[]
  foundcarouseltoppages: ICarouseltoppagesItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
